import { render, staticRenderFns } from "./dropdown-items.vue?vue&type=template&id=9fb357e2&scoped=true"
import script from "./dropdown-items.vue?vue&type=script&lang=js"
export * from "./dropdown-items.vue?vue&type=script&lang=js"
import style0 from "./dropdown-items.vue?vue&type=style&index=0&id=9fb357e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb357e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fb357e2')) {
      api.createRecord('9fb357e2', component.options)
    } else {
      api.reload('9fb357e2', component.options)
    }
    module.hot.accept("./dropdown-items.vue?vue&type=template&id=9fb357e2&scoped=true", function () {
      api.rerender('9fb357e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/dropdown-items.vue"
export default component.exports